  <template>
  <q-page padding >
    p:{{params}}
    q:{{query}}
  </q-page>
</template>

<script>
/* eslint-disable */
import gql from 'graphql-tag'
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'NewEnquiry',
  data() {
    return{
      params:"",
      query:""
    }
  },
  methods: {
    moment,
    async createEnquiry_mutation(input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation createEnquiry($input: EnquiryInput) {
              createEnquiry(input: $input){
                id
                firstName
                lastName
                message
                email
                phone
                type
                timezone
                utm_source
                utm_medium
                utm_campaign
                territory
                eid
                notes
              }
            }
          `,
          variables:{
            input
          }
        })
        console.log('r',response.data.createEnquiry);
    },
  },
  async created(){
    console.log('XXXXXXXXXXXX');
      let q = this.$route.query
      let input = {
        firstName: q.first_name || '',
        lastName:q.last_name || '',
        message:q.message || '',
        email:q.email || '',
        phone:q.phone || '',
        type:q.enquiry_type || '',
        timezone:q.timezone || '',
        utm_source:q.utm_source || '',
        utm_medium:q.utm_medium || '',
        utm_campaign:q.utm_campaign || '',
        territory:q.territory || '',
      }

      this.createEnquiry_mutation(input);
      
      // this.params =  p;
      // this.query = this.$route.query
      window.location.href = "https://climbicp.com.au/thank-you";
  }
}
</script>


<style scoped>
 .my-card {
     width:400px;
     height:200px;
}
</style>